import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import CustomInput from '../../../../../Utility/Components/CustomInput';

class GroupModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }

    render() {
        const { handleChange, name, name_error } = this.props
        return (
            <>
                <div className="modalinnerbody modalinnerbodycontactgroup">
                    <div className="innerbodydimension profilepersonalcon ">
                        <div className="row">
                            <div className="col-md-12">
                                <CustomInput
                                    parentClassName="input_field_inner"
                                    labelName="Group Name"
                                    name="text"
                                    type="text"
                                    value={name}
                                    labelPresent={true}
                                    onChange={(e) => handleChange(e, "name")}
                                    errorLabel={name_error}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

GroupModalContent.propTypes = {

}

GroupModalContent.defaultProps = {
    className: "modalcustomize mondimension",
    headerclassName: "close_btn_icon",
    buttonClassName: "btn btn-primary",
    BodyContent: "",
    buttonContent: "",
    bodyClassName: ""
}

const mapStateToProps = (globalState) => {
    return {

    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(GroupModalContent)));